import { render } from "./ObjectiveTreeItem.vue?vue&type=template&id=b4bfad60&scoped=true"
import script from "./ObjectiveTreeItem.vue?vue&type=script&lang=js"
export * from "./ObjectiveTreeItem.vue?vue&type=script&lang=js"

import "./ObjectiveTreeItem.vue?vue&type=style&index=0&id=b4bfad60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4bfad60"]])

export default __exports__